import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

function Career() {
    const page = "career";
  return (
    <div>
        {/* <Header /> */}
            <section className={`hero ${page}`}>
                <h1>Careers</h1>
            </section>

            {/* About DMC section */}
            <section className="section section--white">
            <div className="fullscreen-kicker">
                <h3>Careers at DMCO</h3>
            </div>
            <div className="container">
                <p>
                At DMCO, we believe our people are our greatest strength. As a fast-growing leader in drilling materials and industrial solutions, we offer opportunities for individuals who are passionate 
                about <strong>innovation, integrity, and excellence</strong>.
                </p>
                <p>
                    Whether you are an experienced professional or a fresh graduate, DMCO provides an environment where you can <strong>develop your skills, grow your career, and make a real impact</strong> on industries that shape the future.
                </p>
            </div>
            </section>

            <section className="section section--grey">
            <div className="fullscreen-kicker">
                <h3>Why Join DMCO</h3>
            </div>
            <div className="container">
                <ul className="kpi-list">
                <li><strong>Global Exposure</strong>: Work with top industry players across Saudi Arabia and international markets.</li>
                <li><strong>Career Growth</strong>: Structured development programs, mentorship, and leadership opportunities.</li>
                <li><strong>Innovation-Driven</strong>: Contribute to projects that leverage cutting-edge technology and sustainable practices.</li>
                <li><strong>Inclusive Culture</strong>: We value diversity, collaboration, and respect for every employee.</li>
                <li><strong>Purpose & Impact</strong>: Be part of the Kingdom’s Vision 2030 transformation</li>
                </ul>
                <a className="btn-apply" href="/career/application-form">Apply</a>
            </div>
            </section>    

            <section className="section section--white">
            <div className="fullscreen-kicker">
                <h3>Graduate & Internship Programs</h3>
            </div>
            <div className="container">
                <p>
                Our graduate and internship programs provide hands-on training, real project exposure, and the opportunity to grow into a long-term career with DMCO.
                </p>
                <a className="btn-apply" href="/career/application-form">Apply</a>
            </div>
            </section>
        {/* <Footer /> */}
    </div>
  )
}

export default Career